export
const BW_ROLES = [
    'UPDATE DEPENDANT',
    'DISABLE SPONSORSHIP',
    'GROUP APPROVE PAYMENT',
    'BULK_SPONSORSHIP',
    'REALIZE_POLICIES',
    'CREATE EXECUTIVE',
    'LIST_NOTIFICATIONS',
    'VIEW GROUP INVOICE HISTORY',
    'GET USER DETAILS',
    'EDIT DOB',
    'UPLOAD DOC',
    'uma_authorization',
    'view-profile',
    'VIEW GROUP STEWARD SUMMARY',
    'REGISTER_POLICY',
    'LIST PAYMENT',
    'VIEW_POLICY',
    'EDIT ID NUMBER',
    'CLOSE_POLICY',
    'APPROVE STEWARD',
    'VIEW INVOICE',
    'CREATE DEPENDANT',
    'VIEW_PROFILE',
    'EDIT DEPENDANT',
    'RECONCILE',
    'CREATE EVENT',
    'VERIFY STEWARD',
    'GROUP APPROVE EXECUTIVE',
    'CREATE_BENEFICIARY',
    'REMOVE DEPENDANT',
    'CREATE PAYMENT',
    'VIEW_POLICY_SPONSOR',
    'UPDATE STEWARD',
    'AGENT',
    'VIEW GROUP SUMMARY',
    'ENABLE ADDON',
    'SEARCH POLICY',
    'UPDATE_POLICY_PACKAGE',
    'VIEW_BENEFICIARY',
    'APPROVE_REFUND',
    'UPDATE EXECUTIVE',
    'GROUP CAPTURE MEMBER',
    'VIEW BENEFICIARY',
    'SUBMIT FOR APPROVAL',
    'VIEW_DEPENDANT',
    'REJECT PAYMENT',    
    'UPDATE MEMBER',
    'REGISTER SUBSCRIBER',
    'CREATE MEMBER',
    'LIST_POLICY_MEMBERS',
    'VIEW POLICY',
    'VIEW ADDON',
    'GROUP REMOVE MEMBER',
    'LIST DEPENDANTS',
    'VIEW GROUP EXECUTIVE',
    'ASSIGN TO VERIFIER',
    'APPROVE_CHANGE_MSISDN',
    'BULK_CREATE_POLICY',
    'REMOVE_POLICY_SPONSOR',
    'GROUP SUBMIT FOR APPROVAL',
    'LIST STEWARDS',
    'RETURN STEWARD',
    'BULK_CREATE_PAYMENT',
    'LIST EXECUTIVES',
    'INVOICE STEWARD',
    'ADD DEPENDANT',
    'VIEW NOTIFICATION',
    'CHANGE_MSISDN',
    'REFUND',
    'ACTIVATE STEWARD',
    'VIEW PAYMENTS',
    'LIST_INVOICES',
    'GROUP CREATE GROUP',
    'GROUP CHANGE PACKAGE',
    'REMOVE MEMBER',
    'GROUP SUSPEND OR UNSUSPEND MEMBER',
    'EDIT EXECUTIVE',
    'GROUP PAYMENT UPLOAD',
    'RECOMMEND FOR REJECTION',
    'CAPTURE INDEPENDENT WITNESS',
    'REMOVE EXECUTIVE',
    'GROUP UPLOAD EXECUTIVE',
    'CREATE STEWARD',
    'INITIATE_REFUND',
    'REALIZE_POLICY',
    'GROUP APPROVE GROUP',
    'SUBMIT FOR VERIFICATION',
    'VIEW GROUP ADDONS',
    'CLOSE POLICY',
    'GROUP INVOICE GROUP',
    'LIST MEMBERS',
    'DISABLE ADDON',
    'BULK_CREATE_DEPENDANT',
    'offline_access',
    'LIST INVOICES',
    'VIEW GROUP PAYMENT HISTORY',
    'VERIFY PAYMENT',
    'REJECT STEWARD',
    'CHANGE PACKAGE',
    'VIEW POLICY HISTORY',
    'UPDATE_PAYMENT_MODE',
    'VIEW GROUP MEMBER',
    'UPDATE_AUTO_DEBIT',
    'LIST_PAYMENTS',
    'REMOVE BENEFICIARY',
    'GROUP DOWNLOAD MEMBER DATABASE',
    'GROUP CAPTURE EXECUTIVE',
    'GROUP ADD MEMBER',
    'LIST_POLICY_HISTORY',
    'REMOVE_BENEFICIARY',
    'DISABLE AUTO DEBIT',
    'EDIT_POLICY'
];

export const BW_CLAIM_ROLES_REQ = [
    'LIST CLAIM DOCUMENTS',
    'CREATE CLAIM DOCUMENT',
    'SUBMIT CLAIM',
    'LIST CLAIMS',
    'UPDATE CLAIM DOCUMENT',
    'UPLOAD CLAIM DOC',
    'VERIFY CLAIM',
    'UPDATE CLAIM',
    'CREATE CLAIM',
    'SUBMIT CLAIM FOR APPROVAL',
    'REMOVE CLAIM'
]

export const BW_CLAIM_ROLES= [
    'SECOND CLAIM APPROVAL',
    'LIST CLAIM DOCUMENTS',
    'LIST CLAIMS',
    'FIRST CLAIM REJECTION',
    'PAYOUT CLAIM',
    'FIRST CLAIM APPROVAL',
    'THIRD CLAIM APPROVAL',
    'REMOVE CLAIM'
]